import React from 'react';
import providers from '../context';

const Providers = ({ children }) =>
  providers.reduce((acc, Provider) => <Provider>{acc}</Provider>, children);

export default Providers;
